<template>
  <v-container class="pa-0" fluid>
    <div class="login">
      <div class="l-header">
        <v-img :src="require('@/assets/logo_check_motors_white.png')" contain height="54" />
      </div>
      <div class="welcome-background"></div>
      <div class="box-login">
        <v-card flat tile width="100%" class="pb-0">
          <v-card-text v-if="login.login_type === 'sms'">
            <h3 class="pb-3 text-center">CÓDIGO {{ login.phone }}</h3>
            <v-divider></v-divider>
            <img
              v-if="isSendingSms"
              src="https://cdn.dribbble.com/users/386061/screenshots/1349248/media/07d510c2a68b9868f7c7514b9d8cd59c.gif"
              class="sending-sms-loader"
            />
            <div v-else class="pt-4">
              <p class="mb-0" style="text-align: center">Informe abaixo o código recebido</p>
              <v-otp-input
                v-model="login.token"
                :disabled="loading"
                @keydown.enter="confirmSmsToken()"
                ref="confirmToken"
                class="mt-2"
                length="6"
                color="#314e5d"
                type="number"
              ></v-otp-input>
              <v-btn @click="confirmSmsToken()" block large depressed color="#48c295" elevation="0" style="width: 30%" :disabled="!login.token || login.token.length < 6 || loading" class="mt-1 white--text">
                Entrar
              </v-btn>
              <div class="retry">
                <div class="action">
                  <span class="retry-action">O código não chegou?</span>
                  <a v-if="retryTimeout === 0" href="javascript:void(0)" @click="sendSmsToken(true)">Solicitar um novo código</a>
                </div>
                <div class="timeout" v-if="retryTimeout > 0">
                  <span>Aguarde {{ retryTimeout }} segundos para pedir novamente</span>
                </div>
              </div>
            </div>
          </v-card-text>
          <v-card-text v-if="login.login_type === 'password'">
            <h3 class="pb-3 text-center">ENTRAR COM SENHA</h3>
            <v-divider></v-divider>
            <div class="pt-2">
              <v-text-field
                v-model="login.password"
                :disabled="loading"
                :append-icon="login.show_password ? 'mdi-eye' : 'mdi-eye-off'"
                :type="login.show_password ? 'text' : 'password'"
                :key="login.show_password"
                @click:append="login.show_password = !login.show_password"
                @keydown.enter="confirmPassword()"
                hide-details
                class="mt-2"
                color="#314e5d"
                outlined
                prepend-inner-icon="mdi-lock"
                label="Senha"
              ></v-text-field>
              <v-btn @click="confirmPassword()" block large depressed color="#48c295" elevation="0" style="width: 30%" :disabled="!login.password || loading" class="mt-3 white--text">
                Entrar
              </v-btn>
              <div class="mt-3 text-center">
                <a href="javascript:void(0)" @click="handleSendSmsToken()">Entrar com código</a>
              </div>
            </div>
          </v-card-text>
          <v-card-text v-if="login.login_type === null">
            <h3 class="pb-3 text-center">ACESSAR MINHA CONTA</h3>
            <v-divider></v-divider>
            <img
              v-if="isSendingSms"
              src="https://cdn.dribbble.com/users/386061/screenshots/1349248/media/07d510c2a68b9868f7c7514b9d8cd59c.gif"
              class="sending-sms-loader"
            />
            <div v-else class="pt-4">
              <v-text-field
                v-model="login.phone"
                :disabled="loading"
                @keydown.enter="checkLoginType()"
                hide-details
                class="mt-0 mb-4 px-0"
                v-mask="['(##) ####-####', '(##) #####-####']"
                color="#314e5d"
                clearable
                outlined
                label="Número de Celular"
                type="text"
              ></v-text-field>
              <v-btn @click="checkLoginType()" dark large depressed color="#48c295" elevation="0" block> ENTRAR </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </div>
      <div class="box-register">
        <v-card flat tile width="100%" class="pb-0">
          <v-card-text>
            <h3 class="pb-3 text-center">O MELHOR CHECKLIST AUTOMOTIVO</h3>
            <v-divider></v-divider>
            <div class="checklist mt-4">
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Orçamento;</span>
              </div>
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Assinatura do cliente;</span>
              </div>
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Enviar serviço por WhatsApp;</span>
              </div>
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Fotos e videos no checklist;</span>
              </div>
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Acompanhamento da equipe;</span>
              </div>
              <div class="item-check">
                <img :src="require('@/assets/icons/check.png')" height="26" />
                <span>Sem limite de fotos, videos e anexos;</span>
              </div>
            </div>
            <v-btn @click="register_modal.open = true" outlined dark large depressed color="#48c295" elevation="0" block> CADASTRE-SE </v-btn>
          </v-card-text>
        </v-card>
      </div>
      <v-bottom-sheet v-model="register_modal.open" :persistent="loading">
        <v-sheet class="pa-4" style="color: rgba(0, 0, 0, 0.6)">
          <div v-if="register_modal.success && register_modal.form">
            <h3 class="pb-3 text-center" style="font-size: 1.1em !important">CADASTRADO COM SUCESSO</h3>
            <v-divider></v-divider>
            <img :src="require('@/assets/icons/11.svg')" height="200px" style="margin: 0 auto; display: block" />
            <div v-if="register_modal.form.organization.cpf_cnpf" class="checklist-register mt-4 mb-1">
              <div class="mb-4 text-center">
                <b>{{ register_modal.form.user.name.split(' ')[0] }}</b
                >, agora você pode fechar esta janela e entrar com seu número de celular.
              </div>
              <div class="item-check">
                <div class="icon">
                  <img :src="require('@/assets/icons/check.png')" width="100%" />
                </div>
                <div class="text">
                  Empresa cadastrada: <br />
                  <b style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{
                    register_modal.form.organization.name.toUpperCase()
                  }}</b>
                </div>
              </div>
              <div class="item-check">
                <div class="icon">
                  <img :src="require('@/assets/icons/check.png')" width="100%" />
                </div>
                <div class="text">
                  Usuário cadastrado: <br />
                  <b>{{ register_modal.form.user.phone }}</b>
                </div>
              </div>
            </div>
            <v-btn @click="register_modal.open = false" dark large depressed color="#48c295" elevation="0" block> FECHAR </v-btn>
          </div>
          <div v-else>
            <b>Dados da empresa</b>
            <v-text-field
              v-debounce:1s="verifyCnpj"
              v-model="register_modal.form.organization.cpf_cnpf"
              v-mask="'##.###.###/####-##'"
              :disabled="loading"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="CNPJ da empresa"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="register_modal.form.organization.name"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              dense
              outlined
              label="Nome da empresa"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="register_modal.form.organization.address"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="Endereço"
              type="text"
            ></v-text-field>
            <b>Dados do usuário</b>
            <v-text-field
              v-model="register_modal.form.user.phone"
              v-mask="['(##) ####-####', '(##) #####-####']"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="Celular WhatsApp"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="register_modal.form.user.name"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="Nome completo"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="register_modal.form.user.email"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="E-mail"
              type="text"
            ></v-text-field>
            <v-text-field
              v-model="register_modal.form.user.password"
              :disabled="loading || !validateCpfCnpj(register_modal.form.organization.cpf_cnpf)"
              hide-details
              class="mt-4 mb-4 px-0"
              color="#314e5d"
              clearable
              outlined
              dense
              label="Senha"
              type="password"
            ></v-text-field>
            <v-divider class="pb-4"></v-divider>
            <div class="px-2 pb-4">
              <div>
                <div style="font-size: 13px;">
                  <span>Ao realizar o cadastro você confirma ser maior de 18 anos e aceitar os </span>
                  <span style="cursor: pointer; color: #41a982" @click="openTerms"
                    >Termos de Uso e a Política de Privacidade</span
                  >.
                </div>
              </div>
            </div>
            <v-divider class="pb-4"></v-divider>
            <v-btn @click="registerRequest()" :loading="loading" dark large depressed color="#48c295" elevation="0" block> REALIZAR CADASTRO </v-btn>
          </div>
        </v-sheet>
      </v-bottom-sheet>
      <div class="footer-checkmotors">
        <div @click="openSupportWhatsApp()" style="color: #48c295; margin-bottom: 5px">
          <v-icon color="#48c295" size="20px" style="margin-top: -2px">mdi-whatsapp</v-icon> Fale conosco
        </div>
        {{ new Date().getFullYear() }} © <b>CheckMotors v3.7.41</b> <br />
        <a @click="openTerms()" style="color: rgba(0, 0, 0, 0.6) !important;">Termos de uso e política de privacidade</a>
      </div>
    </div>
  </v-container>
</template>

<script>
import { cnpj, cpf } from 'cpf-cnpj-validator';
import { setToken, deleteToken } from '@/services/tokenService';

export default {
  async created() {
    await deleteToken();
  },
  data: () => ({
    retryTimeout: 0,
    isSendingSms: false,
    loading: false,
    login: {
      login_type: null,
      phone: null,
      token: null,
      password: null,
      show_password: false
    },
    register_modal: {
      open: false,
      success: false,
      form: {
        user: {
          name: null,
          email: null,
          phone: null,
          password: null
        },
        organization: {
          name: null,
          address: null,
          cpf_cnpf: null
        }
      }
    },
    acceptTerm: false,
  }),
  methods: {
    sendSmsToken(retry = false) {
      const self = this;
      self.loading = true;
      self.login.token = null;
      self.isSendingSms = true;

      self.startCountdown();

      self.$http
        .post(`/auth/send/token${retry ? '?retry=true' : ''}`, {
          phone: self.login.phone.match(/\d+/g).join('')
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.isSendingSms = false;
          }, 8000);
        });
    },
    confirmSmsToken() {
      const self = this;

      if (!self.login.token || self.login.token.length < 6) {
        this.$toast.error('Informe um código válido');
        return;
      }

      self.loading = true;

      self.$http
        .post('/auth/confirm/token', {
          phone: self.login.phone.match(/\d+/g).join(''),
          sms_token: self.login.token,
          user_agent: navigator.userAgent
        })
        .then(async (response) => {
          await setToken(response.data.auth_token);
          setTimeout(() => {
            window.location.href = '/';
          }, 1500);
        })
        .catch(() => {
          self.token = null;
          self.loading = false;

          self.toast.error('Código inválido');
        });
    },
    confirmPassword() {
      const self = this;
      self.loading = true;
      self.$http
        .post('/auth/confirm/password', {
          phone: self.login.phone.match(/\d+/g).join(''),
          password: self.login.password,
          user_agent: navigator.userAgent
        })
        .then(async (response) => {
          await setToken(response.data.auth_token);
          setTimeout(() => {
            window.location.href = '/';
          }, 1000);
        })
        .catch(() => {
          self.token = null;
          self.loading = false;
        });
    },
    coletarRastreio() {
      try {
        if (window.CheckMotorsRastreio && typeof window.CheckMotorsRastreio.coletar === 'function') {
          return window.CheckMotorsRastreio.coletar();
        }
      } catch (error) {
        return {};
      }
      return {};
    },
    registerRequest() {
      if (!this.validateCpfCnpj(this.register_modal.form.organization.cpf_cnpf)) {
        this.$toast.error('Informe um CNPJ válido');
        return;
      }

      this.loading = true;

      const form = {
        ...this.register_modal.form,
        user: {
          ...this.register_modal.form.user,
          email: this.register_modal.form.user.email.trim().toLowerCase(),
          password: this.register_modal.form.user.password
        },
        rastreio: this.coletarRastreio()
      };

      this.$http
        .post('/public/organization/register', form)
        .then(() => {
          this.register_modal.success = true;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    validateCpfCnpj(cpfCnpj) {
      if (!cpfCnpj) return false;
      return !!(cpf.isValid(cpfCnpj) || cnpj.isValid(cpfCnpj));
    },
    verifyCnpj() {
      const self = this;
      if (self.validateCpfCnpj(self.register_modal.form.organization.cpf_cnpf)) {
        self.loading = true;
        fetch(`https://brasilapi.com.br/api/cnpj/v1/${self.register_modal.form.organization.cpf_cnpf.replace(/\D/g, '')}`)
          .then((response) => response.json())
          .then((data) => {
            self.loading = false;
            self.register_modal.form.organization.name = data.nome_fantasia;
            self.register_modal.form.organization.address = `${data.descricao_tipo_de_logradouro} ${data.logradouro}, ${data.numero} ${data.complemento}, ${data.bairro} / ${data.municipio} - ${data.uf}`;
          })
          .catch(() => {
            self.loading = false;
          });
      }
    },
    openSupportWhatsApp() {
      window.open(`whatsapp://send?phone=5565992774481`);
    },
    checkLoginType() {
      const self = this;

      if (!self.login.phone || self.login.phone.length < 14) {
        this.$toast.error('Informe um número de celular válido');
        return;
      }

      self.loading = true;

      self.$http
        .post('/auth/check/type', {
          phone: self.login.phone.match(/\d+/g).join('')
        })
        .then((r) => {
          if (r.data.login_type === 'sms') {
            self.sendSmsToken();
            setTimeout(() => {
              self.login.login_type = r.data.login_type;
              self.loading = false;
            }, 8000);
          } else {
            self.login.login_type = r.data.login_type;
            self.loading = false;
          }
        })
        .catch(() => {
          self.loading = false;
        });
    },
    startCountdown() {
        if (this.retryTimeout > 0) return;

        this.retryTimeout = 60;

        const interval = setInterval(() => {
            this.retryTimeout -= 1;
            if (this.retryTimeout <= 0) {
                clearInterval(interval);
                this.retryTimeout = 0;
            }
        }, 1000);
    },
    handleSendSmsToken() {
      this.login.login_type = 'sms';
      this.sendSmsToken();
    },
    openTerms() {
      this.$store.dispatch('Auth/openTerms');
    },
  },
  watch: {
    'register_modal.open': {
      handler(open) {
        if (!open) {
          this.register_modal = {
            open: false,
            success: false,
            form: {
              user: {
                name: null,
                email: null,
                phone: null,
                password: null
              },
              organization: {
                name: null,
                address: null,
                cpf_cnpf: null
              }
            }
          };
        }
      }
    }
  }
};
</script>

<style lang="scss">
a:link {
  text-decoration: none;
}

.sending-sms-loader {
  height: 124px;
  margin: 0 auto;
  display: block;
  border-radius: 5px;
  filter: grayscale(1);
  opacity: 0.6;
  margin-top: 15px;
  transition: all 0.1s ease;
}

.login {
  .l-header {
    background-color: rgb(63, 80, 95);
    width: 100%;
    padding: 10px;
  }

  .welcome-background {
    width: 100%;
    height: 126px;
    padding: 10px 20px;
    background-color: #eee;
    content: ' ';
  }

  .box-login {
    width: 92%;
    margin: 0 auto;
    margin-top: -108px;
    border: 2px solid #eee;
    overflow: hidden;
    border-radius: 6px;
    background-color: #fff;
  }

  .box-register {
    width: 92%;
    margin: 0 auto;
    margin-top: 16px;
    border: 2px solid #eee;
    overflow: hidden;
    border-radius: 6px;
    background-color: #fff;

    .checklist {
      overflow: hidden;

      .item-check {
        width: 100%;
        margin-bottom: 14px;
        float: left;

        img {
          float: left;
        }

        span {
          float: left;
          padding: 2px 5px;
        }
      }
    }
  }

  .footer-checkmotors {
    color: #b2b2b2;
    font-size: 12px;
    text-align: center;
    margin-top: 14px;
    margin-bottom: 20px;
  }
}

.checklist-register {
  overflow: hidden;

  .item-check {
    width: 100%;
    margin-bottom: 14px;
    background-color: #eee;
    border-radius: 5px;
    float: left;

    .icon {
      float: left;
      padding: 8px 0px 8px 14px;
      width: 50px;
      margin-top: 7px;
    }

    .text {
      float: left;
      padding-left: 12px;
      margin: 10px;
      width: calc(100% - 70px);
      border-left: 1px solid #d4d4d4;
    }
  }
}

.retry {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  gap: 4px;

  .action {
    display: flex;
    gap: 6px;

    .retry-action {
      color: #A0AEC0;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }

    a {
      color: #379686;
      cursor: pointer;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .timeout {
    color: #8493a3;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
